import { WalletAccount } from '@exodus/models';
import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const selectorFactory = (walletAccountsSelector) => createSelector(walletAccountsSelector, (walletAccounts) => {
    const { source, id } = WalletAccount.DEFAULT;
    const existing = Object.values(walletAccounts).filter((w) => w.source === source && ((!id && !w.id) || w.id === id));
    const indexes = existing.map((w) => w.index ?? 0);
    return Math.max(...indexes) + 1;
});
const nextIndexSelector = defineSelectorFactory({
    id: 'nextIndex',
    selectorFactory,
    dependencies: [
        { selector: 'data' },
    ],
});
export default nextIndexSelector;
